import { API } from "../config/axiosConfig";
import endpoints from "../endpoints/endpoints";

export const cartModule = {
  placeOrder: async (payload) => {
    try {
      const response = await API.post(endpoints.placeOrder, payload);
      return {
        success: true,
        data: response.data,
        message: response.data.message || "order placed successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to place order",
        error: error.response?.data || error,
      };
    }
  },

  getRate: async (payload) => {
    try {
      const response = await API.post(endpoints.getRate, payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to get shipping rate",
        error: error.response?.data || error,
      };
    }
  },
};
